const STORAGE_KEY = 'rm_guided_project_setup_skipped_team_pids'
const skippedGuidedProjectSetupTeamPids = new Set<string>()

const getTeamKey = (teamPid: string | number) => String(teamPid)

const hasWindow = () => typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

const loadPersistedSkippedTeamPids = (): Set<string> => {
  if (!hasWindow()) {
    return new Set()
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return new Set()
    }

    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) {
      window.localStorage.removeItem(STORAGE_KEY)
      return new Set()
    }

    return new Set(parsed.filter((entry): entry is string => typeof entry === 'string'))
  } catch {
    window.localStorage.removeItem(STORAGE_KEY)
    return new Set()
  }
}

const syncPersistedSkippedTeamPids = () => {
  const persisted = loadPersistedSkippedTeamPids()
  skippedGuidedProjectSetupTeamPids.clear()

  for (const teamPid of persisted) {
    skippedGuidedProjectSetupTeamPids.add(teamPid)
  }
}

const persistSkippedTeamPids = () => {
  if (!hasWindow()) {
    return
  }

  if (skippedGuidedProjectSetupTeamPids.size === 0) {
    window.localStorage.removeItem(STORAGE_KEY)
    return
  }

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(skippedGuidedProjectSetupTeamPids).sort()))
}

export function markGuidedProjectSetupSkipped(teamPid: string | number): void {
  syncPersistedSkippedTeamPids()
  skippedGuidedProjectSetupTeamPids.add(getTeamKey(teamPid))
  persistSkippedTeamPids()
}

export function hasSkippedGuidedProjectSetup(teamPid: string | number | null | undefined): boolean {
  if (teamPid === null || teamPid === undefined) {
    return false
  }

  syncPersistedSkippedTeamPids()
  return skippedGuidedProjectSetupTeamPids.has(getTeamKey(teamPid))
}

export function clearGuidedProjectSetupSkipped(teamPid: string | number): void {
  syncPersistedSkippedTeamPids()
  skippedGuidedProjectSetupTeamPids.delete(getTeamKey(teamPid))
  persistSkippedTeamPids()
}
